import { createAction } from 'redux-act';

import FacebookPage from '../../../../models/interfaces/FacebookPage';
import TimestampPayload from '../../TimestampPayload';

export interface FetchFacebookPagesPayload {
  placeUuid: string;
  accessToken: string;
}
export const fetchFacebookPages = createAction<FetchFacebookPagesPayload>('FETCH_FACEBOOK_PAGES');

export interface FacebookPagesFetchResponsePayload extends TimestampPayload {
  placeUuid: string;
  facebookPages: FacebookPage[];
}
export const facebookPagesFetched = createAction<FacebookPagesFetchResponsePayload>('FACEBOOK_PAGES_FETCHED');

export const facebookPagesFetchFailed = createAction<FacebookPagesFetchResponsePayload>('FACEBOOK_PAGES_FETCH_FAILED');
